import React, { useMemo } from "react";
import { Fingerprint } from "lucide-react";

import heroFingerprint from "@/assets/utu_hero_new.png";

export function NoiseOverlay() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-0 opacity-[0.10] mix-blend-soft-light"
      style={{
        backgroundImage:
          "url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22400%22 height=%22400%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%224%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22400%22 height=%22400%22 filter=%22url(%23n)%22 opacity=%220.7%22/%3E%3C/svg%3E')",
      }}
    />
  );
}

export function ParticleField({ count = 46 }) {
  const points = useMemo(() => {
    // Deterministic pseudo-random field (so it doesn't jump on rerenders)
    const seed = 1337;
    let s = seed;
    const rand = () => {
      s = (s * 1103515245 + 12345) % 2147483647;
      return s / 2147483647;
    };

    return Array.from({ length: count }).map((_, i) => {
      const x = rand() * 100;
      const y = rand() * 100;
      const size = 1 + rand() * 2.2;
      const opacity = 0.14 + rand() * 0.36;
      const drift = 10 + rand() * 24;
      const delay = rand() * 2.4;
      return { id: `p-${i}`, x, y, size, opacity, drift, delay };
    });
  }, [count]);

  return (
    <div aria-hidden="true" className="absolute inset-0 z-0">
      {points.map((p) => (
        <span
          key={p.id}
          className="absolute rounded-full bg-[hsl(var(--utu-gold))] blur-[0.2px] animate-utu-float"
          style={{
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            opacity: p.opacity,
            transform: "translate3d(0,0,0)",
            animationDelay: `${p.delay}s`,
            "--utu-drift": `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
}

export function BrandMark({ className = "" }) {
  return (
    <div
      className={`relative inline-flex h-9 w-9 items-center justify-center ${className}`}
    >
      <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle_at_30%_20%,rgba(251,191,36,0.35),rgba(0,0,0,0))] blur-xl" />
      <div className="absolute inset-0 rounded-full border border-white/10 bg-white/5 backdrop-blur-xl" />
      <Fingerprint className="relative h-5 w-5 text-[hsl(var(--utu-gold))]" />
    </div>
  );
}

export function FingerprintOrb({ className = "" }) {
  // Use provided hero image. It is transparent/background-removed, so we render it cleanly.
  return (
    <div className={`relative ${className}`}>
      <div className="absolute -inset-6 sm:-inset-8 lg:-inset-10 rounded-full bg-[radial-gradient(circle_at_45%_40%,rgba(251,191,36,0.22),rgba(0,0,0,0))] blur-2xl lg:blur-3xl opacity-70" />

      <div className="relative mx-auto w-full max-w-[420px] sm:max-w-[580px] md:max-w-[720px] lg:max-w-[820px]">
        <img
          src={heroFingerprint}
          alt="UTU fingerprint orb"
          className="w-full h-auto select-none drop-shadow-[0_0_30px_rgba(245,158,11,0.4)] brightness-110 contrast-105 object-contain"
          draggable={false}
        />
      </div>
    </div>
  );
}
